/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'
import { updateUserRoleDataRoleSchema } from './UpdateUserRoleDataRoleSchema'

export const updateUserRoleDataSchema = z.object({
	userId: z.string(),
	role: updateUserRoleDataRoleSchema,
})

export type UpdateUserRoleDataSchema = z.infer<typeof updateUserRoleDataSchema>
